<div class="add-virtual-cash">
  <h2 class="headline">
    {{ "VIRTUAL_POS_PAGE.MODAL_EDIT.TITLE" | translate }}
  </h2>
  <form
    [formGroup]="form"
    (ngSubmit)="sendForm()"
    class="add-virtual-cash__body">
    <div class="add-virtual-cash__body-inputs">
      <div class="scroll-block">
        <div
          [class.error]="form.get('terminalName')?.invalid && form.get('terminalName')?.touched"
          class="input-block">
          <p class="input-line__name">
            <label for="terminalName">
              {{ "VIRTUAL_POS_PAGE.MODAL_ADD.NAME" | translate }}
            </label>
          </p>
          <input
            formControlName="terminalName"
            id="terminalName"
            class="input"
            type="text"
            placeholder="" />
          <ng-container *ngIf="form.get('terminalName')?.invalid && form.get('terminalName')?.touched">
            <span
              *ngIf="terminalNameRequireError"
              class="input-block__error">
              {{ "VIRTUAL_POS_PAGE.MODAL_ADD.REQUIRED" | translate }}
            </span>
          </ng-container>
        </div>

        <div
          *ngIf="!this.loadingData?.is_for_p2p"
          class="line">
          <div
            [class.error]="form.get('commission')?.invalid && form.get('commission')?.touched"
            class="input-block percent">
            <p class="input-line__name">
              <label for="commission"> {{ "VIRTUAL_POS_PAGE.MODAL_ADD.COMMISSION" | translate }}</label>
            </p>
            <input
              formControlName="commission"
              id="commission"
              class="input"
              placeholder="{{ 'VIRTUAL_POS_PAGE.MODAL_ADD.COMMISSION_PLACEHOLDER' | translate }}"
              mask="000"
              type="text" />
            <ng-container *ngIf="form.get('commission')?.invalid && form.get('commission')?.touched">
              <span
                *ngIf="commissionRequireError"
                class="input-block__error">
                {{ "VIRTUAL_POS_PAGE.MODAL_ADD.REQUIRED" | translate }}
              </span>
              <span
                *ngIf="commissionMaxError"
                class="input-block__error">
                {{ "VIRTUAL_POS_PAGE.MODAL_ADD.MAX_ERROR" | translate }}
              </span>
            </ng-container>
          </div>
        </div>

        <div class="line bill">
          <span
            (click)="isTerminalsBlockOpen = !isTerminalsBlockOpen"
            class="title">
            {{ "VIRTUAL_POS_PAGE.INFO" | translate }}
          </span>
          <!--Тип виртуальной кассы-->
          <div class="list">
            <span class="type-name"> {{ "VIRTUAL_POS_PAGE.MODAL_EDIT.VIRTUAL_POS_TYPE" | translate }} </span>
            <span class="type">
              {{
                loadingData?.is_aft
                  ? ("VIRTUAL_POS_PAGE.MODAL_EDIT.AFT" | translate)
                  : loadingData?.is_for_p2p
                    ? ("VIRTUAL_POS_PAGE.MODAL_EDIT.P2P_OPERATIONS" | translate)
                    : ("VIRTUAL_POS_PAGE.MODAL_EDIT.ACCURING" | translate)
              }}
            </span>
            <!--Минимальная сумма-->
            <div class="list">
              <span class="type-name"> {{ "VIRTUAL_POS_PAGE.MODAL_ADD.MIN_SUM" | translate }} </span>
              <div class="type-container">
                <span class="type">
                  {{ loadingData?.min_amount?.toFixed(2) }}
                </span>
                <span class="currency">{{ loadingData?.currency }}</span>
              </div>
            </div>
            <!--Максимальная сумма-->
            <div class="list">
              <span class="type-name"> {{ "VIRTUAL_POS_PAGE.MODAL_ADD.MAX_SUM" | translate }} </span>
              <div class="type-container">
                <span class="type">
                  {{ loadingData?.max_amount?.toFixed(2) }}
                </span>
                <span class="currency">{{ loadingData?.currency }}</span>
              </div>
            </div>
          </div>
        </div>

        <div
          class="empty"
          *ngIf="!selectedTerminals.length">
          <p class="attention">{{ "VIRTUAL_POS_PAGE.MODAL_EDIT.EMPTY_ATTENTION" | translate }}</p>
          <p>
            {{ "VIRTUAL_POS_PAGE.MODAL_EDIT.EMPTY_DESCRIPTION_1" | translate }}
            <a (click)="router.navigate(['/support'])">
              {{ "VIRTUAL_POS_PAGE.MODAL_EDIT.EMPTY_DESCRIPTION_2" | translate }}
            </a>
            {{ "VIRTUAL_POS_PAGE.MODAL_EDIT.EMPTY_DESCRIPTION_3" | translate }}
          </p>
        </div>

        <div
          *ngIf="selectedTerminals.length"
          [class.active]="isTerminalsBlockOpen"
          class="terminals">
          <span
            (click)="isTerminalsBlockOpen = !isTerminalsBlockOpen"
            class="title">
            {{ "VIRTUAL_POS_PAGE.TERMINALS" | translate }}
          </span>
          <div *ngFor="let terminal of selectedTerminals; index as i">
            <div class="terminal">
              <span class="bank-name"> {{ terminal.bank_name }} </span>
              <span class="terminal-name">
                {{ terminal.name || ("VIRTUAL_POS_PAGE.MODAL_EDIT.EMPTY" | translate) }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="btn-block">
        <button
          [disabled]="form.invalid || isSending"
          type="submit"
          class="btn btn-accent btn-send">
          {{ "VIRTUAL_POS_PAGE.MODAL.SAVE" | translate }}
        </button>
        <button
          (click)="closeModal()"
          type="button"
          class="btn btn-light btn-send">
          {{ "VIRTUAL_POS_PAGE.MODAL.CANCEL" | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
